import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-zuni-report',
  templateUrl: './zuni-report.component.html',
  styleUrls: ['./zuni-report.component.scss']
})
export class ZuniReportComponent implements OnInit {

  constructor( ) { }

  ngOnInit() {

  }

}




// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/zuni-report/zuni-report.component.ts